<template>
    <div
        class="modal fade"
        id="confirmServicesModal"
        tabindex="-1"
        aria-labelledby="confirmServicesModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <form action="" @submit.prevent="formController">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmServicesModalLabel">
                            Nº Orden - {{ order.order_number }}
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <table
                            cellspacing="0"
                            cellpadding="0"
                            border="0"
                            class="operation_table"
                        >
                            <thead>
                                <tr>
                                    <th>Mano de Obra</th>
                                    <th>Val. Unit</th>
                                    <th>Cant.</th>
                                    <th>Valor</th>
                                    <th>Dcto. (%)</th>
                                    <th>Valor final</th>
                                    <th>¿Realizar?</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="operation in order.generalOperations"
                                    :key="operation.id"
                                    :class="{ active: operation.accepted }"
                                >
                                    <td>{{ operation.name }}</td>
                                    <td>{{ operation.price }}</td>
                                    <td>{{ operation.quantity }}</td>
                                    <td>{{ operation.value }}</td>
                                    <td>{{ operation.discount }}</td>
                                    <td>{{ operation.subtotal }}</td>
                                    <td>
                                        <label class="input-switch">
                                            <input
                                                type="checkbox"
                                                :id="'operation' + operation.id"
                                                v-model="operation.accepted"
                                                @change="
                                                    updateStatus(
                                                        operation,
                                                        true
                                                    )
                                                "
                                            />
                                            <span
                                                class="input-switch__slider"
                                            ></span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            cellspacing="0"
                            cellpadding="0"
                            border="0"
                            class="part_table"
                        >
                            <thead>
                                <tr>
                                    <th>Repuesto</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="part in order.operationParts"
                                    :key="part.id"
                                    :class="{ active: part.accepted }"
                                >
                                    <td>{{ part.name }}</td>
                                    <td>{{ part.price }}</td>
                                    <td>{{ part.quantity }}</td>
                                    <td>{{ part.value }}</td>
                                    <td>{{ part.discount }}</td>
                                    <td>{{ part.subtotal }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            cellspacing="0"
                            cellpadding="0"
                            border="0"
                            class="part_table"
                        >
                            <thead>
                                <tr>
                                    <th>Terceros</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="third in order.thirdParties"
                                    :key="third.id"
                                    :class="{ active: third.accepted }"
                                >
                                    <td>{{ third.name }}</td>
                                    <td>{{ third.price }}</td>
                                    <td>{{ third.quantity }}</td>
                                    <td>{{ third.value }}</td>
                                    <td>{{ third.discount }}</td>
                                    <td>{{ third.subtotal }}</td>
                                    <td>
                                        <label class="input-switch">
                                            <input
                                                type="checkbox"
                                                :id="'third' + third.id"
                                                v-model="third.accepted"
                                                @change="updateStatus(third)"
                                            />
                                            <span
                                                class="input-switch__slider"
                                            ></span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            cellspacing="0"
                            cellpadding="0"
                            border="0"
                            class="part_table"
                        >
                            <thead>
                                <tr>
                                    <th>Otros cargos</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="other in order.otherCharges"
                                    :key="other.id"
                                    :class="{ active: other.accepted }"
                                >
                                    <td>{{ other.name }}</td>
                                    <td>{{ other.price }}</td>
                                    <td>{{ other.quantity }}</td>
                                    <td>{{ other.value }}</td>
                                    <td>{{ other.discount }}</td>
                                    <td>{{ other.subtotal }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>SUB-TOTAL</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ order.subtotal }}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>IGV</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ order.taxes }}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>TOTAL</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ order.total }}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn--outline"
                            data-bs-dismiss="modal"
                        >
                            Cancelar
                        </button>
                        <button type="submit" class="btn btn--green">
                            Aprobar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { inject, watch } from "vue";
import { customAlert } from "../../../general/js/utils/swalMessages";

export default {
    props: {
        url_store: {
            type: String,
            default: "",
        },
    },
    setup(props, { emit }) {
        const order = inject("order");

        function getPriceByOperations() {
            const operationsActive = order.value.generalOperations.filter(
                (element) => element.accepted
            );

            return operationsActive.reduce(
                (a, b) => a + accounting.unformat(b.subtotal),
                0
            );
        }

        function getPriceByParts() {
            const partsActive = order.value.operationParts.filter(
                (element) => element.accepted
            );

            return partsActive.reduce(
                (a, b) => a + accounting.unformat(b.subtotal),
                0
            );
        }

        function getPriceByThirdParties() {
            const thirdPartiesActive = order.value.thirdParties.filter(
                (element) => element.accepted
            );

            return thirdPartiesActive.reduce(
                (a, b) => a + accounting.unformat(b.subtotal),
                0
            );
        }

        function getPriceByOthers() {
            const othersActive = order.value.otherCharges.filter(
                (element) => element.accepted
            );

            return othersActive.reduce(
                (a, b) => a + accounting.unformat(b.subtotal),
                0
            );
        }

        function getPrices() {
            const subtotal =
                getPriceByOperations() +
                getPriceByParts() +
                getPriceByThirdParties() +
                getPriceByOthers();
            const taxes = subtotal * 0.18;
            const total = subtotal + taxes;

            order.value.subtotal = accounting.formatNumber(
                subtotal,
                2,
                ",",
                "."
            );
            order.value.taxes = accounting.formatNumber(taxes, 2, ",", ".");
            order.value.total = accounting.formatNumber(total, 2, ",", ".");
        }

        watch(
            () => order,
            (currentValue, oldValue) => {
                if (currentValue) {
                    getPrices();
                }
            }
        );

        const updateStatus = (operation, isOperation = false) => {
            if (operation.hasOwnProperty("is_main") && operation.is_main) {
                const subOperationParts = order.value.operationParts.filter(
                    (part) => part.main_operation_id == operation.id
                );

                subOperationParts.map((part) => {
                    part.accepted = operation.accepted;

                    if (!operation.accepted && part.quantity == 0) {
                        return false;
                    }

                    if (!operation.accepted && part.quantity > 0) {
                        part.quantity -= 1;
                    }

                    if (operation.accepted) {
                        part.quantity += 1;
                    }
                });

                order.value.otherCharges.map((element) => {
                    element.accepted = operation.accepted;

                    if (!operation.accepted && element.quantity == 0) {
                        return false;
                    }

                    if (!operation.accepted && element.quantity > 0) {
                        element.quantity -= 1;
                    }

                    if (operation.accepted) {
                        element.quantity += 1;
                    }
                });
            } else {
                order.value.operationParts.map((part) => {
                    if (
                        isOperation &&
                        ((Array.isArray(part.operation_id) &&
                            part.operation_id.indexOf(operation.id)) ||
                            part.operation_id == operation.id)
                    ) {
                        part.accepted = operation.accepted;

                        if (!operation.accepted && part.quantity == 0) {
                            return false;
                        }

                        if (!operation.accepted && part.quantity > 0) {
                            part.quantity -= 1;
                        }

                        if (operation.accepted) {
                            part.quantity += 1;
                        }
                    }
                });
            }

            getPrices();
        };

        const formController = async () => {
            const operations = JSON.parse(
                JSON.stringify(order.value.generalOperations)
            ).map((element) => {
                element.accepted = element.accepted ? 1 : 0;

                return element;
            });

            const parts = JSON.parse(
                JSON.stringify(order.value.operationParts)
            ).map((element) => {
                element.accepted = element.accepted ? 1 : 0;
                return element;
            });

            const thirdParties = JSON.parse(
                JSON.stringify(order.value.thirdParties)
            ).map((element) => {
                element.accepted = element.accepted ? 1 : 0;

                return element;
            });

            const others = JSON.parse(
                JSON.stringify(order.value.otherCharges)
            ).map((element) => {
                element.accepted = element.accepted ? 1 : 0;

                return element;
            });

            const acceptedOperations = operations
                .concat(parts, thirdParties, others)
                .filter((element) => {
                    return element.accepted == 1;
                })
                .map((element) => {
                    return element;
                });

            Swal.fire({
                icon: "warning",
                title: "¡Advertencia!",
                text: "Una vez guardado el registro, este no podrá ser alterado. ¿Está seguro que desea guardar?",
                showCancelButton: true,
                confirmButtonText: "¡Sí, guardar!",
                cancelButtonText: "¡No, cancelar!",
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const { data } = await axios.request({
                            url: props.url_store,
                            method: "POST",
                            data:
                                acceptedOperations.length > 0
                                    ? acceptedOperations
                                    : {
                                          order_header_id: order.value.id,
                                      },
                        });

                        if (data.type == 1) {
                            emit("close-modal");
                            emit("refresh-table");
                        }

                        customAlert(data);
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        };

        return {
            order,
            updateStatus,
            formController,
        };
    },
};
</script>
